import type { EligiblePromotion } from '@libs/common-types';

export const sortProductAlgoliaPromotions = (
    productPromotions: EligiblePromotion[]
) => [...productPromotions].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
